import Vue from "vue";
import axios from "axios";

Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
const getController = self.customSetting.getPendingFiles;
const postController = self.customSetting.postPendingFiles;

export default {
  // 3-1
  QryPrjPendingList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryPrjPendingList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  QryPrjDetail: (context, prjNo) => {
    return axios.get(`${baseApi}/${getController}/QryPrjDetail?prjNo=${prjNo}`);
  },
  VertifyPendingFile: (context, data) => {
    return axios.post(`${baseApi}/${postController}/VertifyPendingFile`, data);
  },
  QryDailyPendingList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryDailyPendingList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  QryDailyDetail: (context, apply_pk) => {
    return axios.get(
      `${baseApi}/${getController}/QryDailyDetail?apply_pk=${apply_pk}`
    );
  },
  QryUrgentPendingList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryUrgentPendingList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  QryUrgentDetail: (context, prjNo) => {
    return axios.get(
      `${baseApi}/${getController}/QryUrgentDetail?prjNo=${prjNo}`
    );
  },
  QrySpecialPendingList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QrySpecialPendingList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
